module.exports = __webpack_public_path__ + "img/54600.828bed33.jpg";